<template>
    <div class="layout-container">
        <div class="login">
            <div class="login-content">
                <div class="login-content-wai">
                    <van-field
                            v-model="phone"
                            left-icon="contact"
                            placeholder="请输入账号"
                    />
                    <div style="text-align: center;margin-top: 10px;">
                        <van-button type="primary" style="width: 88%;" @click="login">登 录</van-button>
                    </div>
                </div>
            </div>
            <div class="res">
                <span>{{deptName}}</span>
                <!--        <router-link to="/register" class="regis">立即注册！</router-link>-->
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId, setCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                phone: '',
                deptName: '',
            };
        },
        async created() {
            this.deptName = this.$route.params.deptName
            this.deptId = getDeptId()
        },
        methods: {
            async login() {
                if (this.phone == '') {
                    return this.$notify({type: 'danger', message: '登录账号不能为空'});
                }
                let data = {
                    loginName: this.phone,
                    deptId: "3ED926EA6A6B4CA7BEC71EEBF12349ED",
                }
                let res = await this.$post("/fw/mnLogin", data)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    this.$router.push('/mys')
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .layout-container {
        margin: 0 auto;
        height: 100%;
        background-size: 100% 100%;
        position: relative;
    }

    .login {
        width: 65%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .login-content {
        width: 100%;
        padding-top: 25px;
        padding-bottom: 25px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .login-content-wai {
        width: 88%;
    }

    .imgs {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -35px;
        left: 38%;
    }

    .res {
        color: rgb(153, 153, 153);
        font-weight: bold;
        font-size: 13px;
        background-color: rgb(255, 255, 255);
        margin: 0 auto;
        line-height: 46px;
        text-align: center;
        box-shadow: 0 3px 3px rgba(21, 62, 78, 0.8);
        margin-top: 20px;
    }

    .regis {
        color: rgb(52, 119, 182);
        cursor: pointer;
    }

    .van-button {
        height: 32px;
    }

    .van-button--primary {
        color: #fff;
        background-color: darkgray;
        border: 1px solid darkgray;
    }
</style>
